/**
 * R5FormPair + R5Field + R5Grid2
 * -----------------------------------------------------------
 * Two-column form layout used on the M1 Account page.
 *
 * Usage:
 *   <R5FormPair
 *     main={
 *       <>
 *         <h3>Edit Profile</h3>
 *         <R5Grid2>
 *           <R5Field label="Nickname"><input value={nickname} ... /></R5Field>
 *           <R5Field label="Email"><input ... /></R5Field>
 *         </R5Grid2>
 *         <R5Field label="Bio"><textarea ... /></R5Field>
 *         <button className="r5-pack-cta r5-pack-cta--bright">Save</button>
 *       </>
 *     }
 *     aside={
 *       <>
 *         <R5AvatarCard initials="P" name="Captain Perry" role="Captain · Verified" />
 *         <h3>Quick Stats</h3>
 *         <R5Field label="Lifetime tokens"><input value="…" disabled /></R5Field>
 *       </>
 *     }
 *   />
 */
import React from 'react';

export function R5FormPair({ main, aside, className = '', children, ...rest }) {
  const cls = ['r5-form-pair', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {children !== undefined ? (
        children
      ) : (
        <>
          <div className="r5-form-pair__main">{main}</div>
          {aside && <aside className="r5-form-pair__aside">{aside}</aside>}
        </>
      )}
    </div>
  );
}

export function R5Field({ label, htmlFor, className = '', children, ...rest }) {
  const cls = ['r5-field', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {label && <label htmlFor={htmlFor}>{label}</label>}
      {children}
    </div>
  );
}

export function R5Grid2({ className = '', children, ...rest }) {
  const cls = ['r5-grid2', className].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}

export default R5FormPair;
